import React from "react";
import styled from "styled-components";
import media from "../assets/css/media";
import theme from "../assets/css/theme";
import bg from "../assets/img/home_section_bg_22.jpg";
import { Content } from "../components";
import { GAME_YEAR } from "../modules/constants/squad";
import { navigateToDraw } from "../modules/utils/dom_helpers";

const FirstSection = styled.div`
	background: url("${bg}") center no-repeat #000000;
	background-size: cover;
	padding: 40px 0;
	min-height: calc(100vh - 400px);
	display: flex;
	align-items: center;
	justify-content: center;
`;

const OffSeasonContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
`;

const TagLine = styled.h3`
	text-align: center;
	font-family: ${theme.base_font};
	color: #fff;
	padding-bottom: 40px;
	font-size: 34px;
	font-weight: bold;
	line-height: 1.3;
	max-width: 600px;
	margin: 0 auto;
	@media (max-width: ${media.desktop}) {
		font-size: 24px;
		line-height: 1.25;
		padding-bottom: 20px;
		max-width: 315px;
	}
`;

const ButtonWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	width: 343px;
	margin-right: 20px;
	&:last-child {
		margin-right: 0;
	}

	p {
		flex: 1 1 100%;
		color: #fff;
		margin-top: 1em;
		text-align: center;
	}

	@media (max-width: ${media.desktop}) {
		flex: 1 1 100%;
		width: 90%;
		max-width: 90%;

		margin-right: 0;
		margin-bottom: 0.5em;
	}
`;

const Button = styled.div`
	flex: 1 1 100%;
	border-radius: 4px;
	background: #008540;
	height: 50px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #fff;
	text-transform: uppercase;
	letter-spacing: 3.5px;
	cursor: pointer;
	transition: all 0.3s ease;
	font-size: 14px;
	font-weight: 500;
	line-height: 1.5;
	&:hover {
		background: #00cf5d;
	}
`;

const Controls = styled.div`
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
	@media (max-width: ${media.desktop}) {
		flex-wrap: wrap;
	}
`;

const OffSeason: React.FC = () => (
	<FirstSection>
		<OffSeasonContent>
			<Content>
				<TagLine>
					Forecast your {GAME_YEAR} NRL season soon!
				</TagLine>
				<Controls>
					<ButtonWrapper>
						<Button onClick={navigateToDraw}>{GAME_YEAR} NRL Draw</Button>
					</ButtonWrapper>
				</Controls>
			</Content>
		</OffSeasonContent>
	</FirstSection>
);

export default OffSeason;
